import { sendParent } from 'xstate5';

import { getOutOfStockModificationNames } from '../../helpers';
import { type CustomizationMachineAction, type ParentEvent } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Tells the parent which default ingredients are out of stock, and so will be
 * left off the product, and its net price without them.
 *
 * NOTE: Not wired in by default. A parent that spawns this machine provides it
 *       as `onOutOfStockIngredientsFound`, which runs once the product loads.
 */
export const reportOutOfStockIngredients: CustomizationMachineAction = sendParent(
  (args): ParentEvent => {
    const { context, self } = args;

    const initialModifications = context.modifications?.initial ?? [];

    return {
      type: 'customization.out-of-stock-ingredients-found',
      actorId: self.id,
      ingredientNames: getOutOfStockModificationNames(initialModifications),
      netPrice: context.netPrice,
    };
  },
);
